import { Injectable } from "@angular/core";
import PasswordValidator from "@starley/password-validator-br";

/**
 * Classe responsavel por validar senha
 * @author Starley Cazorla
 */

@Injectable({ providedIn: 'root' })
export class PasswordValidatorService {
    newPassword = new PasswordValidator();

    /**
     * Define as configurações e validações para a senha
     */
    async setConfig(odlPwd: any, isloggedArea: boolean) {
        this.newPassword
            .is().min(8, "Conter o minimo de 8 caracteres")
            // .is().max(10, "Conter entre 4 e 10 caracteres")
            .has().uppercase(1, "1 letra maiúscula")
            .has().lowercase()
            .has().digits(1, "Conter 1 números")
            .has().symbols(0, "1 caractere especial (! @ # $ % * & )")
            .has().not().spaces()
            .is().not().oneOf(isloggedArea ? [odlPwd] : ['Passw0rd', 'Password123'], isloggedArea ? "A senha cadastrada não pode ser igual a senha anterior." : '');
    }

    /**
     * Verifica o password informado pelo ususario e retorna o status!
     * @param newPwd 
     * @returns 
     */
    async checkPassword(newPwd: any, odlPwd: any, isloggedArea: boolean): Promise<any> {
        await this.setConfig(odlPwd, isloggedArea);

        let detailsList: any = this.newPassword.validate(newPwd, { details: true, language: 'pt-Br' });

        /** Foi necessário pois o plugin retorna um json dentro de um array! 
         * Porem com valores duplicados... Essa funçao abaixo concatena dados iguais
         */
        let parsed_array = detailsList.map((val: any) => { return JSON.stringify(val) });
        let filtered_array = parsed_array.filter((value: any, ind: any) => parsed_array.indexOf(value) == ind).map((val: string) => { return JSON.parse(val) });


        return isloggedArea ? await this.updateDescription(filtered_array) : filtered_array;

    }


    /**
     * Verifica o password informado pelo ususario e retorna o status!
     * @param newPwd 
     * @returns 
     */
    async updateDescription(newPwd: any): Promise<any> {

        const hasObjectMinMax = newPwd.some((element: any) => element.validation === "min" || element.validation === "max");
        const hasObjectUppercase = newPwd.some((element: any) => element.validation === "uppercase");
        const hasObjectDigits = newPwd.some((element: any) => element.validation === "digits");
        const hasObjectSymbols = newPwd.some((element: any) => element.validation === "symbols");

        if (!hasObjectMinMax) {
            newPwd.push({
                sucesso: "Conter entre 8 e 10 caracteres"
            })
        }

        if (!hasObjectUppercase) {
            newPwd.push({
                sucesso: "Letras maiúsculas e minúsculas"
            })
        }

        if (!hasObjectDigits) {
            newPwd.push({
                sucesso: "Letras e números"
            })
        }

        if (!hasObjectSymbols) {
            newPwd.push({
                sucesso: "Ter pelo menos 1 caractere especial (! @ # $ % * & )"
            })
        }

        return newPwd;
    }


}